<template>
    <div class="content with-pagination">

        <modal
            v-model="orderSelection"
            v-show="isModalVisible"
            @close="closeModal"
            @validate="validateModal"/>

        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Commandes</h1>
                    <p>Gestion des commandes</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>


              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.order.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une commande</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.order.export')" @click="exportFile('commandes')">
                  <icon name="download-cloud-01"/>
                  <span>Exporter les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.order.export')" @click="exportFilePDF('commandes')">
                  <icon name="download-cloud-01"/>
                  <span>Exporter les factures (PDF)</span>
                </li>
                <li v-if="orderSelection.data.ids.length >= 1" @click="openModal()"><span>Etat des commandes</span></li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" active-advanced-filter="true" @setInputsValue="setInputsValue" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>
                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <!--<div style="text-align: center;"><span @click="checkAll()">Tout</span></div>-->
                        <div>
                          <datagrid-sort :data="[{name:'Référence', value:'reference'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Montant', value:'amount_total'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center"><span>Paiement</span></div>
                        <div class="center"><span>Etat</span></div>
                        <div class="center"><span>Facture</span></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'Facturation', value:'invoiced_at'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Date création', value:'created_at'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" @click="selectItem(item,item.id)" v-bind:class="[item.is_completed?'':'highlight', item.selected?'selected':'',setClassDataRaw( 'weeboxshop.order.view', item.id )]">
                        <div><input type="checkbox" :value="item.id" name="selection" v-model="orderSelection.data.ids" style="margin-left: 10px;opacity: 0;position: absolute;top: 0;left: 0;"></div>
                        <div class="picture">
                            <i class="icon icon-order-success status-completed" v-if="item.is_completed"></i>
                            <i class="icon icon-order-pending status-pending" v-if="!item.is_completed"></i>
                        </div>
                        <div data-field="reference">
                            <strong class="highlight">{{ item.reference }}</strong>
                            <p v-if="item.address_billing" class="address">
                              <span v-if="item.address_billing.company">{{ item.address_billing.company }}</span>
                              <span v-if="item.address_billing.firstname">{{ item.address_billing.firstname }} {{ item.address_billing.lastname }}</span>
                              <span>{{ item.address_billing.street }} {{ item.address_billing.street_number }}</span>
                              <span>{{ item.address_billing.country }}-{{ item.address_billing.postal_code }} {{ item.address_billing.locality }}</span>
                            </p>
                            <div v-else>
                              <p v-if="item.clientable">{{ item.clientable.name }}</p>
                            </div>
                            <p v-if="item.email">{{ item.email }}</p>

                          <div class="component-product-type" style="margin-top: 0.5em;">
                            <span v-if="item.is_web" class="label product-service">Web</span>
                            <span v-else class="label product-variant">Manuel</span>
                          </div>
                        </div>
                        <div data-field="amount_total">
                            <span class="price highlight"><i>{{ item.currency }}</i> {{ item.amount_total|formatNumber }}</span>
                            <span class="price" v-if="item.currency_base != item.currency"><i>{{ item.currency_base }}</i> {{ item.amount_total_converted|formatNumber }}</span>
                            <p>{{ getBranchById(item.branch_id) }}</p>
                            <p v-if="item.clientable && item.clientable.order_stats">Total CA: {{ item.clientable.order_stats.total_ca|formatNumber }}</p>
                            <p v-if="item.clientable && item.clientable.order_stats">Panier moyen: {{ item.clientable.order_stats.average_order|formatNumber }}</p>
                        </div>
                        <div style="text-align: left;">
                          <order-status :type="item.payment_status" />
                        </div>
                        <div style="text-align: left;">
                          <order-status :type="item.order_status" />
                        </div>
                        <div class="center"><a :href="item.invoice.download_link" target="_blank"><img :src="'/src/assets/images/file-pdf.png'" width="32"/></a></div>
                        <div data-field="invoiced_at" class="center">
                          <date v-model="item.invoice.invoiced_at" :human="false"></date>
                          <div v-if="item.invoice.due_at" style="color: red;font-weight: bold;">{{ item.invoice.due_at }} jours</div>
                        </div>
                        <div><datetime v-model="item.created_at" :human="false"></datetime></div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxshop.order.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                              <li v-if="$aclInterfaceValidator('weeboxshop.order.update',item.id)"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.order.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>

            </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import OrderService from './OrderService.js';
    import Index from '../../../layouts/Index.vue';
    import BranchService from "../../config/branch/BranchService";

    import Modal from './Modal.vue'
    import ScheduleService from "../../reservation/ScheduleService";

    export default {
        extends: Index,
        components:{
            Modal
        },
        data () {
            return {
                branches: null,
                orderSelection: {
                    data: {
                        ids: [],
                        order_status: {},
                        payment_status: {},
                        has_notification: false
                    }
                },
                isModalVisible: false,
                tabsFilter: [
                    {
                        slug: '',
                        name: 'Tout'
                    },
                    {
                        slug: 'pending',
                        name: 'En attente'
                    },
                    {
                        slug: 'in_progress',
                        name: 'En traitement'
                    },
                    {
                        slug: 'completed',
                        name: 'Terminé'
                    }
                ],
                actions: []
            }
        },
        mounted: function(){


            this.filters.inputs.push({
              name: 'Statut du paiement',
              slug: 'invoice',
              type: 'select',
              service: null,
              mandatory: false,
              options: [
                  {id:'draft', name:'Brouillon'},
                  {id:'completed', name:'Payé'},
                  {id:'pending', name:'En attente'}
              ],
              has_languages: false,
              value: null,
            });

            BranchService.query().then(response => {
                this.branches = response.data.data
                this.isLoading = false

                this.filters.inputs.push({
                    name: 'Branche',
                    slug: 'branch',
                    type: 'select',
                    service: null,
                    mandatory: false,
                    options: this.branches,
                    has_languages: false,
                    value: null,
                });
            })

            this.refresh()
        },
        methods: {
            exportFilePDF: function(fileName){

              var d = new Date();
              var dateFile = [
                d.getFullYear(),
                ('0' + (d.getMonth() + 1)).slice(-2),
                ('0' + d.getDate()).slice(-2),
                ('0' + d.getHours()).slice(-2) + "" + ('0' + d.getMinutes()).slice(-2) + "" + ('0' + d.getSeconds()).slice(-2)
              ].join('-');

              var fileName = fileName || 'export';

              if(this.filters.period == 'custom') {
                var query = '?query='  + this.filters.query +
                    '&page='   + this.paginator.page +
                    '&order='  + this.paginator.order +
                    '&sort='   + this.paginator.sort +
                    '&filter=' + this.paginator.filter +
                    '&date_start='  + this.filters.advancedFilters.dateFilter.start_at +
                    '&date_end='    + this.filters.advancedFilters.dateFilter.end_at + this.customQuery + this.clientQuery;
              }else{
                var query = '?query='  + this.filters.query +
                    '&page='   + this.paginator.page +
                    '&order='  + this.paginator.order +
                    '&sort='   + this.paginator.sort +
                    '&filter=' + this.paginator.filter +
                    '&date='   + this.filters.period + this.customQuery + this.clientQuery;
              }

              fileName = fileName + '_' + dateFile + '.pdf'

              OrderService.exportInvoices(query, fileName).then((response) => {
                if( response && response.data ){
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', fileName); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                }
              })
              //this.$router.push({ name: this.$route.name + '-export'});
            },
            getResource: function(){
                return OrderService;
            },
            checkAll: function(){

            },
            selectItem: function(item,id){
                let checked = this.$aclInterfaceValidator('weeboxshop.order.statuschange', id);
                if(checked) {
                    if( this.orderSelection.data.ids.indexOf(id) >= 0 ){
                        this.orderSelection.data.ids.splice(this.orderSelection.data.ids.indexOf(id), 1);
                        item.selected = false;
                    }else{
                        this.orderSelection.data.ids.push(id);
                        item.selected = true;
                    }
                }
            },
            openModal() {
                this.isModalVisible = true
            },
            closeModal() {
                this.tmpEvent = null
                this.isModalVisible = false
            },
            validateModal() {
                OrderService.setMultipleStatus(this.orderSelection.data).then(response => {
                    this.refresh();
                    this.orderSelection.data.ids = [];
                });
                this.closeModal();
            },
            getBranchById: function(id){
                var branch = null;
                for(let item of this.branches)
                {
                    if(item.id == id){
                        return item.name;
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/order/Index.vue